import styles from "./radioInput.module.scss";

interface IProps {
    label: string | Element,
    id: string,
    name: string,
    value: string,
    checked: boolean,
    onChange: () => void,
    labelClass?: string,
}

function RadioInput(props: IProps) {
  const {
    label, id, name, value, checked, onChange, labelClass,
  } = props;
  return (
    <div className={styles.radio_input_container} onClick={onChange}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        className={styles.radio_input}
      />

      <label className={labelClass}>{label}</label>

    </div>
  );
}

export default RadioInput;
